import Icon from '../components/Icon.vue'

Icon.register({
  'pen-nib': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M136.6 138.8l151.4-42.8 128 128-42.8 151.4c-5.1 18-23.6 37.4-41.3 43.3l-279.9 93.3-14.7-14.7 150.1-150.1c6.3 3 13.2 4.8 20.6 4.8 26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48c0 7.4 1.8 14.3 4.8 20.6l-150.1 150.1-14.7-14.7 93.3-279.9c5.9-17.7 25.3-36.3 43.3-41.3zM497.9 74.2c18.8 18.8 18.8 49.2 0 67.9l-56.6 56.5-128-128 56.5-56.6c18.8-18.8 49.2-18.8 67.9 0z'
      }
    ]
  }
})
